import { message } from 'antd';
import { instance } from '../../requests/axios.instance';

// Favoris coupés pour l'activité de l'opportunité (option posée par un
// administrateur) : le serveur répond 403 avec ce code, la liste se remet à jour.
export const FAVORITES_DISABLED = 'favorites_disabled';
export const FAVORITES_DISABLED_MESSAGE = 'Les favoris ont été désactivés pour cette activité.';
const favoritesDisabled = (error) =>
  error?.response?.status === 403 && error.response.data?.code === FAVORITES_DISABLED;

export const deleteProposal = async (id) => {
  try {
    const res = await instance.delete(`/proposal/${id}`);
    if (res.status === 204) {
      message.success('Le document a bien été supprimé.');
      return res.data;
    }
    throw new Error(`DELETE proposal ${id} status code ${res.status}`);
  } catch (error) {
    message.error("Le document n'a pas pu être supprimé.");
    return false;
  }
};

export const renameProposal = async (id, newName) => {
  try {
    const res = await instance.post(`/proposal/${id}/updatename`, {
      name: newName,
    });
    if (res.status === 200) {
      message.success(`Le document ${newName} a bien été renommé.`);
      return res.data;
    }
    throw new Error(`RENAME proposal ${id} status code ${res.status}`);
  } catch (error) {
    message.error("Le document n'a pas pu être renommé.");
    return false;
  }
};

export const duplicateProposal = async (id, newName, oldName) => {
  try {
    const res = await instance.post(`/proposal/${id}/duplicate`, {
      name: newName,
    });
    if (res.status === 200) {
      message.success(`Le document ${oldName} a bien été dupliqué.`);
      return res.data;
    }
    throw new Error(`DUPLICATE proposal ${id} status code ${res.status}`);
  } catch (error) {
    message.error("Le document n'a pas pu être dupliqué.");
    return false;
  }
};

export const createProposal = async (typeId, proposalContent, type) => {
  let res = '';
  try {
    if (type === 'opportunity')
      res = await instance.post(
        `/opportunities/${typeId}/proposal`,
        proposalContent
      );
    else if (type === 'offer')
      res = await instance.post(`/offers/${typeId}/proposal`, proposalContent);
    if (res.status === 200) {
      message.success('Le document a bien été créé.', 1);
      return res.data;
    }
    throw new Error(`CREATE proposal status code ${res.status}`);
  } catch (error) {
    if (favoritesDisabled(error)) return FAVORITES_DISABLED;
    message.error("Le document n'a pas pu être créé.", 1);
    return false;
  }
};

// Favori personnel : l'étoile de la liste des documents d'une opportunité.
export const setProposalFavorite = async (id, favorite) => {
  try {
    if (favorite) await instance.post(`/proposal/${id}/favorite`);
    else await instance.delete(`/proposal/${id}/favorite`);
    return true;
  } catch (error) {
    if (favoritesDisabled(error)) return FAVORITES_DISABLED;
    message.error("Le favori n'a pas pu être enregistré.");
    return false;
  }
};

// Favoris réutilisables sur cette opportunité : même activité, documents seulement.
export const fetchFavoriteProposals = async (opportunityId) => {
  try {
    const { data } = await instance.get(
      `/opportunities/${opportunityId}/favorite_proposals`
    );
    return data;
  } catch (error) {
    if (favoritesDisabled(error)) return FAVORITES_DISABLED;
    message.error("Les favoris n'ont pas pu être chargés.");
    return [];
  }
};

// Favoris autorisés sur l'activité de cette opportunité. Lu sur son activité :
// l'index des documents est un tableau que d'autres écrans consomment tel quel.
// Dans le doute (erreur), pas d'étoile : le serveur refuserait de toute façon.
export const fetchFavoritesEnabled = async (opportunityId) => {
  try {
    const { data } = await instance.get(`/proposals/opportunities/${opportunityId}/work`);
    return data?.proposal_favorites === true;
  } catch (error) {
    return false;
  }
};

// Réponses proposées d'office dans « Recharger les données ? », réglées par
// activité (Admin > Editor > Paramètres). Lues à l'ouverture de la fenêtre, pour
// suivre un changement fait pendant que l'éditeur est ouvert. Dans le doute
// (erreur, ancien serveur), les réponses d'avant ce réglage.
export const DEFAULT_FAVORITE_RELOADS = { variables: true, sections: false, keepAnswers: true };

// « OK » attend cette lecture : au-delà de quelques secondes, les réponses de secours.
const RELOAD_DEFAULTS_TIMEOUT = 5000;

export const fetchFavoriteReloadDefaults = async (opportunityId) => {
  try {
    const { data } = await instance.get(`/proposals/opportunities/${opportunityId}/work`, {
      timeout: RELOAD_DEFAULTS_TIMEOUT,
    });
    const reloads = data?.proposal_favorite_reloads;
    if (!reloads) return DEFAULT_FAVORITE_RELOADS;
    return {
      variables: reloads.variables !== false,
      sections: reloads.sections === true,
      keepAnswers: reloads.keep_answers !== false,
    };
  } catch (error) {
    return DEFAULT_FAVORITE_RELOADS;
  }
};
